// src/DashboardAdmin.js
import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "./firebase/firebase";
import { recalculateAllBalances } from "./tools/recalculateBalances";



export default function DashboardAdmin() {
  const email = localStorage.getItem("email");
  const [accounts, setAccounts] = useState([]);

  // ✅ Load all account balances
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "accounts"), (snap) => {
      setAccounts(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    return () => unsub();
  }, []);

  return (
    <div style={{ padding: 30 }}>
      <h1>CLL Admin Dashboard</h1>
      <p>Welcome, {email}</p>

      <p>
        <strong>Role:</strong> Admin
      </p>

      <p>
        ✅ You have full access to manage accounts, transactions, drivers,
        vehicles, letters, and review ledger reports.
      </p>

      <hr style={{ margin: "20px 0" }} />

      {/* === LUXURY DASHBOARD BALANCE VIEW === */}
      <h2 style={{ fontWeight: 700, marginBottom: 12 }}>
        💼 Company Financial Snapshot
      </h2>

      {(() => {
        // Extract a specific account balance
        const val = (name) => {
          const item = accounts.find((a) =>
            (a.name || "")
              .toLowerCase()
              .includes(name.toLowerCase().trim())
          );
          return Number(item?.currentBalance || 0);
        };

        const fmt = (n) => `AED ${Number(n || 0).toLocaleString()}`;

        // BALANCES
        const comfortTotal = val("cash in hand - comfort line"); // includes Visa
        const visa = val("visa");
        const tanzeelCash = comfortTotal - visa;

        const loliaCash = val("cash in hand - lolia");

        const noqodiCL = val("noqodi wallet - comfort");
        const noqodiLolia = val("noqodi wallet - lolia");

        const netCash = tanzeelCash + loliaCash;

        // UI Components
        const Card = ({ title, children }) => (
          <div
            style={{
              background: "rgba(255,255,255,0.85)",
              backdropFilter: "blur(8px)",
              borderRadius: 16,
              padding: 22,
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
            }}
          >
            <div
              style={{
                fontSize: 18,
                fontWeight: 700,
                marginBottom: 14,
              }}
            >
              {title}
            </div>
            {children}
          </div>
        );

        const Row = ({ label, value, icon, emphasis }) => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "10px 0",
              fontWeight: emphasis ? 800 : 600,
              borderBottom: "1px solid #eee",
              fontSize: emphasis ? 18 : 15,
              color: emphasis ? "#111" : "#333",
            }}
          >
            <span>
              {icon} {label}
            </span>
            <span>{fmt(value)}</span>
          </div>
        );

        return (
          <>
            {/* Net Cash Banner */}
            <div
              style={{
                background: "linear-gradient(135deg,#d4af37,#b8860b)",
                borderRadius: 12,
                padding: "18px 22px",
                color: "#fff",
                fontWeight: 800,
                fontSize: 20,
                marginBottom: 22,
                boxShadow: "0 6px 14px rgba(180,150,0,0.4)",
              }}
            >
              🏦 Net Cash Available Across Companies
              <span style={{ float: "right" }}>{fmt(netCash)}</span>
            </div>

            {/* Side by side cards */}
            <div
              style={{
                display: "grid",
                gap: 20,
                gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))",
              }}
            >
              {/* Comfort Line */}
              <Card title="🚘 Comfort Line Assets">
                <Row
                  label="Total Cash In System"
                  value={comfortTotal}
                  icon="💼"
                  emphasis
                />
                <Row label="Visa Card Balance" value={visa} icon="💳" />
                <Row
                  label="Cash With Tanzeel"
                  value={tanzeelCash}
                  icon="💵"
                />
                <Row label="Noqodi Wallet" value={noqodiCL} icon="🏧" />
              </Card>

              {/* Lolia */}
              <Card title="🚘 Lolia Limousine Assets">
                <Row
                  label="Cash In Hand"
                  value={loliaCash}
                  icon="💵"
                  emphasis
                />
                <Row
                  label="Noqodi Wallet"
                  value={noqodiLolia}
                  icon="🏧"
                />
              </Card>
            </div>
          </>
        );
      })()}

      {/* ======= RECAP BUTTON ======= */}
     
      <button
        onClick={recalculateAllBalances}
        style={{
          padding: "10px 18px",
          background: "#0069d9",
          color: "white",
          fontWeight: "600",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
        }}
      >
        🔄 Recalculate Balances
      </button>
      
    </div>
  );
}
